import FEMALEREPBYROLE from 'data/mantechcar24/female-representation-by-role.json';
import { useRouter } from 'next/router';
import React from 'react';
import {
  Layer,
  Rectangle,
  ResponsiveContainer,
  Sankey,
  Tooltip
} from 'recharts';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';

const FemalesByRole: React.FC = () => {
  const { locale } = useRouter();

  const CustomNode = ({ x, y, height, index, payload }: any): any => {
    return (
      <Layer key={`CustomNode${index}`}>
        <Rectangle
          x={x}
          y={y}
          width={20}
          height={height}
          fill={payload.fill}
          fillOpacity="1"
        />
        <text
          textAnchor="start"
          x={x + 26}
          y={y + height / 2}
          fontSize="14"
          fill="#837E93"
        >
          {payload.name}
        </text>
        <text
          textAnchor="start"
          x={x + 26}
          y={y + height / 2 + 14}
          fontSize="12"
          stroke="#1F1D26"
          strokeOpacity="0.5"
        >
          {payload.value.toLocaleString(locale)}
        </text>
      </Layer>
    );
  };

  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer height={600} width="99%" minWidth={500}>
          <Sankey
            data={FEMALEREPBYROLE}
            node={<CustomNode />}
            nodePadding={30}
            margin={{
              top: 10,
              right: 200,
              bottom: 50
            }}
            link={{ stroke: '#17BECF' }}
          >
            <Tooltip />
          </Sankey>
        </ResponsiveContainer>
      </StyledRecharts>
    </div>
  );
};

export default FemalesByRole;
